import applyFilters from './apply-filters.js';

export default function($) {
  // Sorry future self for doing this pure JS, and retrofitting pagination into this code
  var selected_filter = 'all';
  var loaded_posts = 10;
  var posts_per_load = 10;

  $(document).on('click', '.load-more-posts', function(e) {
    e.preventDefault();

    var list = $(this).attr('data-list');

    loaded_posts += posts_per_load;
    applyFilters($, list, selected_filter, loaded_posts, posts_per_load);
  });
}
